import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Icon from '../../Icons'
import { getDiffColor, getDiffDirectionSymbol } from '../helpers'
import UpsellingBlocker from '../UpsellingBlocker'
import { selectUserRole } from '../../../reducers/userDataReducer'
import { getChatFeedFlagsDueToRole } from '../../../helpers/helpers'
import Can from '../../Can'

const UnifiedInbox = ({ marketingData, userRole }) => {
  const { t } = useTranslation(['building-analytics'])
  const messages =
    marketingData && marketingData.unifiedInbox && marketingData.unifiedInbox.messages

  return (
    <div className="marketing-statistic-row-block">
      <h3 className="title">{t('building-analytics:unifiedInbox.title')}</h3>
      <Can
        on={'Navbar'}
        to={'chat'}
        feedFlag={getChatFeedFlagsDueToRole(userRole)}
        isAll
        allBuildings
        upsellingLink={
          <UpsellingBlocker
            type="unifiedInbox"
            text={t('building-analytics:unifiedInbox.upsellingText')}
            wrapperClassName="marketing-statistic-row-block__upselling-blocker"
          />
        }
      >
        <React.Fragment>
          <span className="subtitle-text">
            {t('building-analytics:unifiedInbox.messagesSentTotal')}
          </span>
          <div className="marketing-statistic-row-block__bottom-wrapper">
            <h3 className="marketing-statistic-row-block__bottom-wrapper__number">
              {messages && messages.value ? messages.value : '0'}
            </h3>
            {messages && !['-', 'Infinity'].includes(messages.percentageDiff) && (
              <div
                className={`marketing-statistic-row-block__bottom-wrapper__percent-wrapper  ${getDiffColor(
                  messages,
                )}`}
              >
                <span className="percent-text">
                  {messages && messages.percentageDiff && messages.percentageDiff !== 'NaN'
                    ? `${getDiffDirectionSymbol(messages.percentageDiff)} ${
                        messages.percentageDiff
                      }%`
                    : '00.00%'}
                </span>
              </div>
            )}
          </div>
          <Link className="redirect-button" to="/dashboard/chat">
            <span>{t('building-analytics:unifiedInbox.goToUnifiedInbox')}</span>
            <Icon
              styles={{ width: '20px', paddingLeft: '5px' }}
              viewBox="0 0 20 20"
              icon={'arrowRight'}
              svgProps={{ stroke: '#646464', strokeLinecap: 'round', strokeLinejoin: 'round' }}
              fill="none"
            />
          </Link>
        </React.Fragment>
      </Can>
    </div>
  )
}

UnifiedInbox.propTypes = {
  marketingData: PropTypes.object,
  userRole: PropTypes.string,
}

export default connect((state) => ({
  userRole: selectUserRole(state),
}))(UnifiedInbox)
